<div [formGroup]="planForm">

    <!--Form Titles-->
    <ccp-form-title [formTitle]="formTitle"></ccp-form-title>

    <div class="planner-content">
        <!--Form Side Nav-->
        <ccp-form-side-nav-bar [tabNames]="tabNames" [group]="planForm" [submitted]="submitted">
        </ccp-form-side-nav-bar>
        <div class="tab-container">
            <!--Plan Settings-->
            <div id="planSettingsTab" class="tab-pane">
                <plan-settings [group]="planForm" [isNew]="isNew" [isCopy]="isCopy" [advertiserInfo]="advertiserInfo">
                </plan-settings>
            </div>
            <hr class="main-section-divider">
            <!--Digital Video Format Settings-->
            <div id="digitalVideoFormatSettingsTab" class="tab-pane">
                <digital-video-format-settings *ngIf="hasDigitalVideo" [group]="digitalPlan" [isNew]="isNew"
                    [hasDefaults]="hasDefaults" [advertiserInfo]="advertiserInfo" [digitalVideoVO]="digitalVideoVO"
                    [status]="status.value">
                </digital-video-format-settings>
            </div>
        </div>
    </div>
    <footer [errorData]="errorData" [group]="planForm" [isSaving]="isSaving"
        (validateAndSavePlan)=validateAndSavePlan()></footer>

</div>